import type { BreakdownItem as BI } from '../generated/checkout.graphql';
import { take } from '../util/takePayload';

export interface BreakdownItem {
  amount: number;
  key: string;
  label: string;
}

export const fromGql = (gqlItem: BI): BreakdownItem => ({
  ...(take<BreakdownItem>(gqlItem, 'amount', 'key', 'label')),
});
